import { getAvarege } from "./getAvarege";

export const CalculateAvaregeRate = calcRate => {
  const rate = new Array();
  for (let item of calcRate) {
    rate.push(item.rate);
  }
  return getAvarege(rate);
};
